import { get } from "@insite/client-framework/Services/ApiService";

type Expertise = {
  name: string;
  isTechnicalSupport: boolean;
  isPriceAndAvailability: boolean;
};

export interface SMESearchEmployeeResult {
    id: string;
    name: string;
    fullName?: string;
    title: string;
    branchName: string;
    photoUrl?: string;
    bioSnippet?: string;
    expertise?: string;
    areasOfExpertise?: string[];
    email?: string;
    phone?: string;
    education?: string;
    trainingsAttended?: string;
    bioFull?: string;
    productTypesExpertise?: Expertise[];
brandsExpertise?: Expertise[];
    isTechnicalSupport?: boolean;
    isPriceAndAvailability?: boolean;
}

export interface SMESearchCategoryResult {
    id: string;
    name: string;
}

export interface SMESearchBrandResult {
    id: string;
    name: string;
}

export interface SMESearchBranchResult {
    id: string;
    name: string;
}

export interface SMESearchResultModel {
    query?: string;
    entityName?: string;
    employeeSearchList?: SMESearchEmployeeResult[];
    brandSearchList?: SMESearchBrandResult[] | null;
    branchSearchList?: SMESearchBranchResult[] | null;
    productSearchList?: SMESearchCategoryResult[] | null;
    categories?: SMESearchCategoryResult[];
    brands?: SMESearchBrandResult[];
    employees?: SMESearchEmployeeResult[];
}

const baseUrl = "/api/v2/centroconnect/sme/search";

export function searchSME(params: { query?: string; id?: string; entity?: string }) {
    const queryParts: string[] = [];
    if (params.query) queryParts.push(`query=${encodeURIComponent(params.query)}`);
    if (params.id) queryParts.push(`id=${encodeURIComponent(params.id)}`);
    if (params.entity) queryParts.push(`entity=${encodeURIComponent(params.entity)}`);
    const qs = queryParts.length > 0 ? `?${queryParts.join("&")}` : "";
    return get<SMESearchResultModel>(`${baseUrl}${qs}`);
}
